<template>
  <div>
    <div class="row">
      <!-- Title -->
      <div class="stage-title">Dokumenty płatności</div>
      <hr/>
    </div>
    <div class="row top-space">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a :class="ppTabClass" aria-current="page" @click="openPaymentsStage('PP')">Polecenia przelewu</a>
        </li>

      </ul>

      <div v-if="currentPaymentDocumentType === 'PP'">
        <PaymentsDocumentsListStage/>
      </div>
<!--      <div v-else-if="currentPaymentType === 'PAID'">-->
<!--        <PaidPaymentsStage/>-->
<!--      </div>-->
<!--      <div v-else-if="currentPaymentType === 'PROBLEMATIC'">-->
<!--              <ProblematicPaymentsStage/>-->
<!--      </div>-->


    </div>





  </div>

</template>


<script>

import {log} from "@/state/pinia/log";
import PaymentsDocumentsListStage from "./PaymentsDocumentsListStage.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";




export default {
  name: "PaymentsDocumentsStage",
  props: {},
  components: {
    PaymentsDocumentsListStage,

  },
  data() {
    return {
      ppTabClass: "nav-link active",
      currentPaymentDocumentType: "PP",

    };
  },
  computed: {


    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },

  },
  methods: {


    openPaymentsStage(openedPaymentType){
      this.currentPaymentDocumentType = openedPaymentType;
      if(openedPaymentType === "PP"){
        this.ppTabClass = "nav-link active";
      }else{
        this.ppTabClass = "nav-link";
      }

    }

  },
  watch: {



  },
  mounted() {

  },
  created() {
    log.log("trigger refresh token")
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();

    });
  },
};
</script>

<style scoped>

.top-space {
  margin-top: 20px;
}


</style>
